import { Inject, Injectable } from '@angular/core';
import { PlotItem } from './models/plot-item.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ApiService } from '../../shared/services/api.service';
import { ErrorHandlerService } from '../../shared/services/error-handler.service';
import { API_BASE_URL } from '../../shared/tokens/api.tokens';
import { ExistenceChecker } from '../../shared/interfaces/existence-checker.interface';
import { catchError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PlotItemsService extends ApiService<PlotItem> implements ExistenceChecker<number, number> {

  override readonly _baseUrl: string;  
  override readonly searchFields = [];

  constructor(@Inject(API_BASE_URL) apiBaseUrl: string, http: HttpClient, errorHandler: ErrorHandlerService) { 
    super(http, errorHandler);
    this._baseUrl = `${apiBaseUrl}plots/authorised-items/`;    
  }

  exists(itemId: number, plotId: number) {    
    let params = new HttpParams().set('authorisedItemId', itemId.toString());    
    return this.http.get<boolean>(`${this._baseUrl}exists/${plotId}`, { params }).pipe(
      catchError(this.handleError)
    );
  }

  deletePlotItem(plotId: number, itemId: number) {
    const params = new HttpParams()
      .set('authorisedItemId', itemId.toString())
      .set('plotId', plotId.toString());

    return this.http.delete(`${this._baseUrl}`, { params }).pipe(
      catchError(this.handleError)
    );
  }
}
